module.exports = __webpack_public_path__ + "static/img/13.a5e40c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/13.png
// module id = xTgf
// module chunks = 0